const de: Record<string, string> = {
  'nav.home': 'Start',
  'nav.settings': 'Einstellungen',
  'nav.back': 'Zurück',
  'login.title': 'Bei AetherCasa anmelden',
  'login.email.submit': 'Magic Link senden',
  'login.email.sent': 'Prüfen Sie Ihre E-Mails',
  'common.loading': 'Laden…',
  'common.error': 'Etwas ist schiefgelaufen',
  'common.retry': 'Erneut versuchen',
  'common.save': 'Speichern',
  'common.cancel': 'Abbrechen',
  'common.close': 'Schließen',
  'error.no_bridge': 'Keine Bridge verbunden',
  'error.command_failed': 'Befehl fehlgeschlagen',
  'error.auth_required': 'Bitte anmelden',
};

export default de;
